
import {
    Routers
} from '@/router/routers'
///otherrouter为所有的路由，根据roles筛选用户可用的路由
function filterRouter(roles, otherRouter) {
    let router = otherRouter.filter(item => {
        if (ifHasPermission(roles, item)) {
            if (item.children && item.children.length) {
                item.children = filterRouter(roles, item.children);
            }
            return true;
        }
        return false;
    })
    return router;
}
///roles为用户有的权限
function ifHasPermission(roles, router) {
    if(router.path.indexOf(":")==-1){
        let rs = roles.some(
            item => {
                return (item === router.path)
            }
        )
        return rs
    }else{
        return true
    }

}
const permission = {
    state: {
        permissionRouter: []
    },
    mutations: {
        SET_ROUTER(state, router) {
            state.permissionRouter = router;
        }
    },
    actions: {
        clearPermissionRouter({commit}){
            return new Promise((resolve)=>{
                commit("SET_ROUTER",[])
                return resolve()
            })
        },
        GetPermissionRouter({ commit }) {
            return new Promise((resole, reject) => {
                let roles= JSON.parse(sessionStorage.getItem("user"))
                roles=roles?roles.auths:[]
                let returnRouter = filterRouter(roles, Routers)
                let vue404 = Routers.find(item => item.name == '404');
                if (vue404) {
                    returnRouter.push(vue404);
                }
                resole(returnRouter);
                commit("SET_ROUTER",returnRouter)
            })
        }
    }
}
export default permission;
